import * as alertUserRoutines from './routines';
import * as isBase64 from 'is-base64';
import * as rootSelectors from '../../selectors/root';
import * as toastRoutines from '../../sagas/routines/toastRoutines';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { rsf } from '../../globals/firebase';
import { saveEventHeroImageSaga } from '../Events/sagas/events';

import * as alertUserSelectors from './selectors';
import * as paths from '../../Providers/paths';
import { deleteFileFromStorageSaga, sendStringSaga } from '../../sagas/filesSaga';
import { extractFileTypeFromBase64 } from '../../helpers/fileTypeRegex';

//PRIVATE METHOD
function* removeAlertUserFileSaga(activeEvent) {
    //Can be refactored
    const filePath = paths.storage_alert_user(activeEvent);

    const previousProfileImage = yield select(alertUserSelectors.selectProfileImage);
    const previousProfileImageThumbnail = yield select(alertUserSelectors.selectProfileImageThumbnail);
    if (previousProfileImage) yield call(deleteFileFromStorageSaga, previousProfileImage, filePath);
    if (previousProfileImageThumbnail) yield call(deleteFileFromStorageSaga, previousProfileImageThumbnail, filePath);
}
//Expects base-64 strings to be passed in
export function* saveAlertUserImageSaga(action) {
    yield put(
        toastRoutines.triggerToast({
            content: 'Updating profile image...',
            options: {
                autoClose: false,
                type: 'info',
            },
        }),
    );
    const { profileImage120, profileImage } = action.payload;
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    const filePath = paths.storage_alert_user(activeEvent);
    const fileType = extractFileTypeFromBase64(profileImage);

    //Can be refactored
    yield call(removeAlertUserFileSaga, activeEvent);
    const downloadablePath120 = yield call(sendStringSaga, {
        filePath: `${filePath}/profileImageThumbnail.${fileType}`,
        imageURL: profileImage120,
    });
    const downloadablePath = yield call(sendStringSaga, {
        filePath: `${filePath}/profileImage.${fileType}`,
        imageURL: profileImage,
    });
    try {
        yield call(rsf.database.patch, paths.moduleConfig(activeEvent, 'inbox', 'AlertUser'), {
            profileImage: downloadablePath,
            profileImageThumbnail: downloadablePath120,
        });
        yield put(toastRoutines.dismissToast());
        yield put(alertUserRoutines.saveAlertUserImage.success({ downloadablePath120, downloadablePath }));
        yield put(toastRoutines.setToastSuccess('Profile image updated!'));
    } catch (error) {
        yield put(toastRoutines.dismissToast());
        yield put(alertUserRoutines.saveAlertUserImage.failure(error));
    }
}

export function* saveAlertUserNameSaga(action) {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    try {
        yield call(rsf.database.patch, paths.moduleConfig(activeEvent, 'inbox', 'AlertUser'), { name: action.payload });
        yield put(alertUserRoutines.saveAlertUserName.success(action.payload));
        yield put(toastRoutines.setToastSuccess('Name updated successfully!'));
    } catch (error) {
        yield put(alertUserRoutines.saveAlertUserName.failure(error));
    }
}

export function* fetchAlertUserSaga(action) {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    try {
        let res = yield call(rsf.database.read, paths.moduleConfig(activeEvent, 'inbox', 'AlertUser'));
        yield put(alertUserRoutines.fetchAlertUser.success(res));
    } catch (error) {
        yield put(alertUserRoutines.fetchAlertUser.failure(error));
    }
}

export function* removeAlertUserAvatarSaga(action) {
    // alert('saga fired');
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    yield call(removeAlertUserFileSaga, activeEvent);
    try {
        yield call(rsf.database.delete, paths.moduleConfig(activeEvent, 'inbox', 'AlertUser', 'profileImage'));
        yield call(rsf.database.delete, paths.moduleConfig(activeEvent, 'inbox', 'AlertUser', 'profileImageThumbnail'));
        yield put(toastRoutines.setToastSuccess('Profile image removed!'));

        yield put(alertUserRoutines.removeAlertUserAvatar.success());
    } catch (error) {
        yield put(alertUserRoutines.removeAlertUserAvatar.failure(error));
    }
}

export function* setInitialSettingsSaga(action) {
    const { eventHero2400, name, profileImage120, profileImage1024 } = action.payload;
    try {
        yield call(saveAlertUserNameSaga, { payload: name });
        //Ensures images are only saved when they are base64/have been selected and not when they are being simply displayed
        if (isBase64(profileImage120, { mime: true })) {
            yield call(saveAlertUserImageSaga, {
                payload: {
                    profileImage120: profileImage120,
                    profileImage: profileImage1024,
                },
            });
        }
        //Ensures images are only saved when they are base64/have been selected and not when they are being simply displayed
        if (isBase64(eventHero2400, { mime: true })) {
            yield call(saveEventHeroImageSaga, { payload: eventHero2400 });
        }
        yield put(alertUserRoutines.setInitialSettings.success());
        yield put(toastRoutines.setToastSuccess('Initial setup complete!'));
    } catch (error) {
        yield put(alertUserRoutines.setInitialSettings.failure(error));
    }
}

export default function* rootAlertUserWatcher() {
    yield takeEvery(alertUserRoutines.saveAlertUserImage.TRIGGER, saveAlertUserImageSaga);
    yield takeEvery(alertUserRoutines.saveAlertUserName.TRIGGER, saveAlertUserNameSaga);
    yield takeEvery(alertUserRoutines.setInitialSettings.TRIGGER, setInitialSettingsSaga);
    yield takeEvery(alertUserRoutines.fetchAlertUser.TRIGGER, fetchAlertUserSaga);
    yield takeEvery(alertUserRoutines.removeAlertUserAvatar.TRIGGER, removeAlertUserAvatarSaga);
}
